import PropTypes from 'prop-types'
import React from 'react'
import { ExtendedStoreFilter } from 'Blocks'

const MobileStoresView = props => {
  return (
    <div className="filter-panel__filter panel">
      {props.data && (
        <ExtendedStoreFilter
          queryString={props.queryString}
          data={props.data}
        />
      )}
    </div>
  )
}

MobileStoresView.propTypes = {
  data: PropTypes.any,
  queryString: PropTypes.any
}

export default MobileStoresView
